import {
    Stack,
    Alert,
    Button
} from "@mui/material";
import { Form, SchemaFormHook } from "@/components/form";
import { z } from "zod/v4";
import { useEmisorConfig } from "@/features/facturacion-electronica/hooks/use-emisor-config";
import { notify } from "@/shared/notification";

// localStorage 
export const timbradoConfigSchema = z.object({
    establecimiento: z.string().min(3, "Establecimiento debe tener 3 dígitos").max(3, "Establecimiento debe tener 3 dígitos"),
    puntoExpedicion: z.string().min(3, "Punto de expedición debe tener 3 dígitos").max(3, "Punto de expedición debe tener 3 dígitos"),
});

interface TimbradoConfigFormProps {
    form: any;
}

export default function TimbradoConfigForm({ form }: TimbradoConfigFormProps) {
    return (
        <Stack gap={3} sx={{ p: 3 }}>
            <Alert severity="info" sx={{ mb: 2 }}>
                Esta configuración se guarda en esta computadora.
            </Alert>

            <Form form={form} gap={2}>
                <Form.TextField
                    name="establecimiento"
                    label="Establecimiento *"
                    placeholder="001"
                    helperText="Código de 3 dígitos"
                    inputProps={{ maxLength: 3 }}
                    size="small"
                    fullWidth
                />

                <Form.TextField
                    name="puntoExpedicion"
                    label="Punto de Expedición *"
                    placeholder="001"
                    helperText="Código de 3 dígitos"
                    inputProps={{ maxLength: 3 }}
                    size="small"
                    fullWidth
                />
            </Form>

            <Stack direction="row" gap={2} justifyContent="flex-end" sx={{ mt: 2 }}>
                <Button
                    onClick={() => form.handleSubmit()}
                    variant="contained"
                >
                    Guardar
                </Button>
            </Stack>
        </Stack>
    );
}

export function TimbradoConfigSchemaForm() {
    const { config, saveConfig } = useEmisorConfig();

    return (
        <SchemaFormHook
            schema={timbradoConfigSchema}
            defaultValues={{
                establecimiento: config?.establecimiento || "",
                puntoExpedicion: config?.puntoExpedicion || "",
            }}
            onSubmit={async ({ value }) => {
                saveConfig(value);
                notify("Configuración guardada correctamente");
            }}
            submitOnce
            closeModalOnSubmit
        >
            {form => <TimbradoConfigForm form={form} />}
        </SchemaFormHook>
    );
}
